module.exports = __webpack_public_path__ + "vsml-chat-reply-icon.png?6514308d2afd2729ed3a88e201b27a8b";